const VIEW_BY_KEYS = {
  DOMAIN: 'domain',
  CLUSTER: 'cluster',
  STANDARD: 'standard',
}

const ANALYZE_BY_KEYS = {
  SCORE: 'score',
  MASTERY_LEVEL: 'masteryLevel',
}

const ANALYZE_BY_OPTIONS = [
  { key: ANALYZE_BY_KEYS.MASTERY_LEVEL, title: 'Mastery Level' },
  { key: ANALYZE_BY_KEYS.SCORE, title: 'Score' },
]

const SCORE_TYPE_KEYS = {
  SCALED_SCORE: 'scaledScore',
  RAW_SCORE: 'rawScore',
}

const SCORE_TYPE_OPTIONS = [
  { key: SCORE_TYPE_KEYS.SCALED_SCORE, title: 'Scaled Score' },
  { key: SCORE_TYPE_KEYS.RAW_SCORE, title: 'Raw Score' },
]

const VIEW_BY_OPTIONS = [
  { key: VIEW_BY_KEYS.DOMAIN, title: 'Domain' },
  { key: VIEW_BY_KEYS.CLUSTER, title: 'Cluster' },
  { key: VIEW_BY_KEYS.STANDARD, title: 'Standard' },
]

const groupInfoMap = {
  term: { dataKey: 'metric.test.termId' },
  test: {
    dataKey: 'metric.test._id',
    labelKey: 'metric.test.name',
    descriptionKey: 'metric.test.name',
  },
  [VIEW_BY_KEYS.DOMAIN]: {
    dataKey: 'skill.domainId',
    labelKey: 'skill.domain',
    descriptionKey: 'skill.domainName',
    filterKey: 'domainIds',
  },
  [VIEW_BY_KEYS.CLUSTER]: {
    dataKey: 'skill.clusterId',
    labelKey: 'skill.cluster',
    descriptionKey: 'skill.clusterName',
    filterKey: 'clusterIds',
  },
  [VIEW_BY_KEYS.STANDARD]: {
    dataKey: 'skill.standardId',
    labelKey: 'skill.standard',
    descriptionKey: 'skill.standardName',
    filterKey: 'standardIds',
  },
}

const reportAtOptions = {
  [VIEW_BY_KEYS.DOMAIN]: {
    key: 'domainId',
    title: 'Domain',
    ...groupInfoMap[VIEW_BY_KEYS.DOMAIN],
    tableGroupKeys: ['domainId', 'test._id', 'test.termId'],
    chartGroupKeys: [
      {
        groupKeys: [groupInfoMap[VIEW_BY_KEYS.DOMAIN]],
        xAxisKey: 'subGroupLabel',
      },
    ],
  },
  [VIEW_BY_KEYS.CLUSTER]: {
    key: 'clusterId',
    title: 'Cluster',
    ...groupInfoMap[VIEW_BY_KEYS.CLUSTER],
    tableGroupKeys: ['domainId', 'clusterId', 'test._id', 'test.termId'],
    chartGroupKeys: [
      {
        groupKeys: [groupInfoMap[VIEW_BY_KEYS.CLUSTER]],
        dashed: true,
        xAxisKey: 'subGroupLabel',
        dy: 30,
      },
      {
        groupKeys: [groupInfoMap[VIEW_BY_KEYS.DOMAIN]],
        xAxisKey: 'groupLabel',
        dy: 45,
      },
    ],
  },
  [VIEW_BY_KEYS.STANDARD]: {
    key: 'standardId',
    title: 'Standard',
    ...groupInfoMap[VIEW_BY_KEYS.STANDARD],
    tableGroupKeys: [
      'domainId',
      'clusterId',
      'standardId',
      'test._id',
      'test.termId',
    ],
    chartGroupKeys: [
      {
        groupKeys: [groupInfoMap[VIEW_BY_KEYS.STANDARD]],
        xAxisKey: 'subGroupLabel',
        dashed: true,
        dy: 30,
      },
      {
        groupKeys: [
          groupInfoMap[VIEW_BY_KEYS.DOMAIN],
          groupInfoMap[VIEW_BY_KEYS.CLUSTER],
        ],
        xAxisKey: 'groupLabel',
        dashed: true,
        dy: 45,
      },
      { groupKeys: [groupInfoMap[VIEW_BY_KEYS.DOMAIN]] },
    ],
  },
}

const GROUP_BY_KEYS = {
  [VIEW_BY_KEYS.DOMAIN]: reportAtOptions[VIEW_BY_KEYS.DOMAIN].key,
  [VIEW_BY_KEYS.CLUSTER]: reportAtOptions[VIEW_BY_KEYS.CLUSTER].key,
  [VIEW_BY_KEYS.STANDARD]: reportAtOptions[VIEW_BY_KEYS.STANDARD].key,
  TEST: 'test._id',
}

const NEXT_VIEW_BY_KEYS = {
  [VIEW_BY_KEYS.DOMAIN]: VIEW_BY_KEYS.CLUSTER,
  [VIEW_BY_KEYS.CLUSTER]: VIEW_BY_KEYS.STANDARD,
  [VIEW_BY_KEYS.STANDARD]: VIEW_BY_KEYS.STANDARD,
}

const CHART_PAGE_SIZE = 12
const TABLE_PAGE_SIZE = 50
const LAMBDA_PAGE_SIZE = 5000
const CSV_FILENAME = 'Data Studio - Domain Analysis.csv'

module.exports = {
  VIEW_BY_KEYS,
  GROUP_BY_KEYS,
  groupInfoMap,
  reportAtOptions,
  ANALYZE_BY_KEYS,
  ANALYZE_BY_OPTIONS,
  SCORE_TYPE_KEYS,
  SCORE_TYPE_OPTIONS,
  VIEW_BY_OPTIONS,
  NEXT_VIEW_BY_KEYS,
  CHART_PAGE_SIZE,
  TABLE_PAGE_SIZE,
  LAMBDA_PAGE_SIZE,
  CSV_FILENAME,
}
